import { render, staticRenderFns } from "./modalsViewZoomImage.vue?vue&type=template&id=20752156&scoped=true"
import script from "./modalsViewZoomImage.vue?vue&type=script&lang=js"
export * from "./modalsViewZoomImage.vue?vue&type=script&lang=js"
import style0 from "./modalsViewZoomImage.vue?vue&type=style&index=0&id=20752156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20752156",
  null
  
)

export default component.exports